import { createFileRoute, Outlet } from '@tanstack/react-router'

import { PageHeader } from '@/components/page-header'
import { parseTasksSearch, type TasksSearch } from '@/components/tasks/tasks-search-schema'
import { TasksWorkspace } from '@/components/tasks/tasks-workspace'
import { Card, CardContent } from '@/components/ui/card'

export const Route = createFileRoute('/_app/tasks')({
  validateSearch: parseTasksSearch,
  component: TasksPage,
})

function TasksPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  const updateSearch = (next: Partial<TasksSearch>) => {
    void navigate({
      search: (current) => ({ ...current, ...next, page: next.page ?? 1 }),
      replace: true,
    })
  }

  return (
    <div className="space-y-5">
      <PageHeader title="Tâches" />

      <Card>
        <CardContent className="pt-6">
          <TasksWorkspace search={search} onSearchChange={updateSearch} />
        </CardContent>
      </Card>

      {/* Panneau de détail : route enfant affichée par-dessus la liste. */}
      <Outlet />
    </div>
  )
}
